var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.125 17.9297L0.593792 35.2164L0.593792 0.643009L30.125 17.9297Z","fill":"#212121"}));
}

Play.defaultProps = {"width":"31","height":"36","viewBox":"0 0 31 36","fill":"none"};

module.exports = Play;

Play.default = Play;
